import envConfig from '@bit/bit.utils.project.config';
const env = process.env.NODE_ENV;

export type Config = {
	orchestratorUrl: string;
	staticBucket: string;
	cookieName: string;

	//use sparingly, global features limit reusability
	feature_markStaticSite: boolean;
	feature_bonusLoaderTexts: boolean;
};

const config = envConfig<Config>(
	{
		development: {
			orchestratorUrl: 'https://stg-capsule.bitsrc.io',
			feature_bonusLoaderTexts: true,
			feature_markStaticSite: true,
		},
		stage: {
			orchestratorUrl: 'https://stg-capsule.bit.dev',
			feature_bonusLoaderTexts: true,
			feature_markStaticSite: true,
		},
		production: {
			orchestratorUrl: 'https://capsule.bit.dev',
		},
		default: {
			orchestratorUrl: 'https://capsule.bit.dev',
			staticBucket: 'https://static.bit.dev',
			cookieName: 'cocyclesSession',
			feature_bonusLoaderTexts: false,
			feature_markStaticSite: false,
		},
	},
	env
);

export default config;
